/**
 * @desc 明细
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(eChapterCode: string | number, options?: any) {
  return updateResponse(
    http(URL + `/eChapter/detail/${eChapterCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
